import React, { PropsWithChildren } from 'react';
import {
  AnimatePresence as FramerAnimatePresence,
  type AnimatePresenceProps,
} from 'framer-motion';

type Props = PropsWithChildren<AnimatePresenceProps>;

export default function AnimatePresence({
  children,
  ...rest
}: Props): JSX.Element {
  // Call AnimatePresence as a function
  const element = FramerAnimatePresence({ children, ...rest });

  // If undefined, render empty fragment
  return element ?? <></>;
}
